import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { LogtoProvider } from '@logto/react';
import { logtoConfig } from '@/auth/logto-config';
import { AuthProvider } from '@/auth/AuthContext';
import { ToastProvider } from '@/components/ui/Toast';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { App } from '@/App';
// i18n: importing the config boots i18next (HTTP backend + language detector).
// Apply <html dir>/<html lang> SYNCHRONOUSLY from the saved language before
// React mounts, so an RTL (Hebrew) session paints right-to-left with no flash.
import i18n, { applyDirAndLang, LANGUAGE_LOCALSTORAGE_KEY } from '@/i18n';
// Brand wordmark font (IOSentraWordmark) — self-hosted, no external fetch.
import '@fontsource/space-grotesk/600.css';
import '@/styles/index.css';

applyDirAndLang(localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY) || i18n.language || 'en');

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary label="root">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          {/* LogtoProvider drives the Authorization Code + PKCE flow when
              AUTH_FLOW=oidc. Harmless when unused (proxy flow). */}
          <LogtoProvider config={logtoConfig}>
            <ToastProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </ToastProvider>
          </LogtoProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
